const DM_OPT_OUT_FIELD_CONFIGS = [
  {
    name: 'firstName',
    required: true,
    validation: { minLength: 2, maxLength: 50 },
  },
  {
    name: 'middleName',
    required: false,
    validation: { maxLength: 50 },
  },
  {
    name: 'lastName',
    required: true,
    validation: { minLength: 2, maxLength: 50 },
  },
  {
    name: 'street',
    required: true,
    validation: { minLength: 5, maxLength: 500 },
  },
  {
    name: 'city',
    required: true,
    validation: { minLength: 2, maxLength: 50 },
  },
  {
    name: 'state',
    required: true,
    validation: { minLength: 2, maxLength: 50, pattern: /^[a-zA-Z]{2}$/ },
  },
  {
    name: 'zip',
    required: true,
    validation: { maxLength: 5, pattern: /^\d{5}$/ },
  },
];

export default DM_OPT_OUT_FIELD_CONFIGS;
